module.exports = __webpack_public_path__ + "static/media/logo-internal.de2ec7d8.png";